import config from "../config";
import axiosInstance from "./AxiosInstance";

export const fetchDealProgress = (id) => {
  const token = JSON.parse(sessionStorage.getItem("userDetails"))?.result
    ?.token;

  return axiosInstance({
    url: config.routes.getDealProgress(id),
    method: "get",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
